export const PERFORM_TEST = 'PERFORM_TEST';

export const OIDC_ACCESS_TOKEN_EXPIRED = 'OIDC_ACCESS_TOKEN_EXPIRED';
export const OIDC_ACCESS_TOKEN_EXPIRING = 'OIDC_ACCESS_TOKEN_EXPIRING';
export const OIDC_SILENT_RENEW_ERROR = 'OIDC_SILENT_RENEW_ERROR';
export const OIDC_USER_UNLOADED = 'OIDC_USER_UNLOADED';
export const OIDC_USER_LOADED = 'OIDC_USER_LOADED';
export const OIDC_USER_SIGNED_OUT = 'OIDC_USER_SIGNED_OUT';

export const REDIRECT_SUCCESS = 'REDIRECT_SUCCESS';
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR';
export const INITIAL_AUTHENTICATION = 'INITIAL_AUTHENTICATION';

export const CLEAR_AVAILABLE_TELS = 'CLEAR_AVAILABLE_TELS';
export const ENSURE_AVAILABLE_TELS = 'ENSURE_AVAILABLE_TELS';
export const LOAD_AVAILABLE_TELS = 'LOAD_AVAILABLE_TELS';
export const LOAD_AVAILABLE_TELS_FAILURE = 'LOAD_AVAILABLE_TELS_FAILURE';
export const LOAD_AVAILABLE_TELS_PENDING = 'LOAD_AVAILABLE_TELS_PENDING';
export const LOAD_AVAILABLE_TELS_SUCCESS = 'LOAD_AVAILABLE_TELS_SUCCESS';

export const CLEAR_SELECTED_ACCOUNT = 'CLEAR_SELECTED_ACCOUNT';
export const ENSURE_SELECTED_ACCOUNT = 'ENSURE_SELECTED_ACCOUNT';
export const LOAD_SELECTED_ACCOUNT = 'LOAD_ACCOUNT_COMPANY';
export const LOAD_SELECTED_ACCOUNT_SUCCESS = 'LOAD_SELECTED_ACCOUNT_SUCCESS';
export const LOAD_SELECTED_ACCOUNT_FAILURE = 'LOAD_SELECTED_ACCOUNT_FAILURE';

export const ENSURE_SELECTED_COMPANY = 'ENSURE_SELECTED_COMPANY';
export const LOAD_SELECTED_COMPANY = 'LOAD_SELECTED_COMPANY';
export const LOAD_SELECTED_COMPANY_SUCCESS = 'LOAD_SELECTED_COMPANY_SUCCESS';
export const LOAD_SELECTED_COMPANY_FAILURE = 'LOAD_SELECTED_COMPANY_FAILURE';

// user roles
export const CLEAR_USER_ROLES = 'CLEAR_USER_ROLES';
export const ENSURE_USER_ROLES = 'ENSURE_USER_ROLES';
export const LOAD_USER_ROLES = 'LOAD_USER_ROLES';
export const LOAD_USER_ROLES_SUCCESS = 'LOAD_USER_ROLES_SUCCESS';
export const LOAD_USER_ROLES_FAILURE = 'LOAD_USER_ROLES_FAILURE';

export const GET_CONNECTIONS = 'GET_CONNECTIONS';

export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';

export const LOAD_FILTER_SETTINGS = 'LOAD_FILTER_SETTINGS';
export const LOAD_FILTER_SETTINGS_FAILURE = 'LOAD_FILTER_SETTINGS_FAILURE';
export const LOAD_FILTER_SETTINGS_SUCCESS = 'LOAD_FILTER_SETTINGS_SUCCESS';

export const SAVE_FILTER_SETTINGS = 'SAVE_FILTER_SETTINGS';
export const SAVE_FILTER_SETTINGS_FAILURE = 'SAVE_FILTER_SETTINGS_FAILURE';
export const SAVE_FILTER_SETTINGS_SUCCESS = 'SAVE_FILTER_SETTINGS_SUCCESS';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const CLOSE_NOTIFICATION_PANEL = 'CLOSE_NOTIFICATION_PANEL';
export const DISMISS_IMPERSONATION_BLOCKED = 'DISMISS_IMPERSONATION_BLOCKED';
export const DISMISS_ALL_NOTIFICATIONS = 'DISMISS_ALL_NOTIFICATIONS';
export const SHOW_IMPERSONATION_BLOCKED = 'SHOW_IMPERSONATION_BLOCKED';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const HIDE_ALL_NOTIFICATION_POPUPS = 'HIDE_ALL_NOTIFICATION_POPUPS';
export const HIDE_NOTIFICATION_POPUP = 'HIDE_NOTIFICATION_POPUP';
export const OPEN_NOTIFICATION_PANEL = 'OPEN_NOTIFICATION_PANEL';

export const CLEAR_SIMS = 'CLEAR_SIMS';
export const EXPORT_SIMS = 'EXPORT_SIMS';
export const EXPIRE_SIMS = 'EXPIRE_SIMS';
export const LOAD_SIMS = 'LOAD_SIMS';
export const LOAD_SIMS_FAILURE = 'LOAD_SIMS_FAILURE';
export const LOAD_SIMS_IF_NEEDED = 'LOAD_SIMS_IF_NEEDED';
export const LOAD_SIMS_PENDING = 'LOAD_SIMS_PENDING';
export const LOAD_SIMS_SUCCESS = 'LOAD_SIMS_SUCCESS';
export const BULK_SIMS_SELECTED = 'BULK_SIMS_SELECTED';
export const CHANGE_SIMS_SELECTED = 'CHANGE_SIMS_SELECTED';
export const DESELECT_SIMS = 'DESELECT_SIMS';
export const SET_SELECTED_SIMS = 'SET_SELECTED_SIMS';
export const SET_VIEWED_SIMS = 'SET_VIEWED_SIMS';
export const UPDATE_GRID_STATE = 'UPDATE_SIM_GRID_STATE';
export const CLEAR_FILTER = 'CLEAR_FILTER';

export const ENSURE_ORANGE_PROVISIONING_ORDER = 'ENSURE_ORANGE_PROVISIONING_ORDER';
export const LOAD_ORANGE_PROVISIONING_ORDER = 'LOAD_ORANGE_PROVISIONING_ORDER';
export const LOAD_ORANGE_PROVISIONING_ORDER_PENDING = 'LOAD_ORANGE_PROVISIONING_ORDER_PENDING';
export const LOAD_ORANGE_PROVISIONING_ORDER_FAILURE = 'LOAD_ORANGE_PROVISIONING_ORDER_FAILURE';
export const LOAD_ORANGE_PROVISIONING_ORDER_SUCCESS = 'LOAD_ORANGE_PROVISIONING_ORDER_SUCCESS';

export const SET_COMMAND_PROVISIONING = 'SET_COMMAND_PROVISIONING';
export const ENSURE_PROVISIONING = 'ENSURE_PROVISIONING';
export const LOAD_PROVISIONING = 'LOAD_PROVISIONING';
export const LOAD_PROVISIONING_PENDING = 'LOAD_PROVISIONING_PENDING';
export const LOAD_PROVISIONING_FAILURE = 'LOAD_PROVISIONING_FAILURE';
export const LOAD_PROVISIONING_SUCCESS = 'LOAD_PROVISIONING_SUCCESS';

export const LOAD_MVNO_BUNDLE_PENDING = 'LOAD_MVNO_BUNDLE_PENDING';
export const LOAD_MVNO_BUNDLE_FAILURE = 'LOAD_MVNO_BUNDLE_FAILURE';
export const LOAD_MVNO_BUNDLE_SUCCESS = 'LOAD_MVNO_BUNDLE_SUCCESS';
export const ENSURE_MVNO_BUNDLE = 'ENSURE_MVNO_BUNDLE';
export const LOAD_MVNO_BUNDLE = 'LOAD_MVNO_BUNDLE';

export const ADD_USER_INTRODUCTION = 'ADD_USER_INTRODUCTION';
export const ADD_USER_INTRODUCTION_FAILURE = 'ADD_USER_INTRODUCTION_FAILURE';
export const CLEAR_USER_INTRODUCTIONS = 'CLEAR_USER_INTRODUCTIONS';
export const LOAD_USER_INTRODUCTIONS = 'LOAD_USER_INTRODUCTIONS';
export const LOAD_USER_INTRODUCTIONS_FAILURE = 'LOAD_USER_INTRODUCTIONS_FAILURE';
export const LOAD_USER_INTRODUCTIONS_IF_NEEDED = 'LOAD_USER_INTRODUCTIONS_IF_NEEDED';
export const LOAD_USER_INTRODUCTIONS_PENDING = 'LOAD_USER_INTRODUCTIONS_PENDING';
export const LOAD_USER_INTRODUCTIONS_SUCCESS = 'LOAD_USER_INTRODUCTIONS_SUCCESS';

export const ENSURE_DIRECTLY_AVAILABLE_COMMAND_TYPES = 'ENSURE_DIRECTLY_AVAILABLE_COMMAND_TYPES';
export const LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES = 'LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES';
export const LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_FAILURE = 'LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_FAILURE';
export const LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_PENDING = 'LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_PENDING';
export const LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_SUCCESS = 'LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_SUCCESS';

export const CLEAR_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER = 'CLEAR_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER';
export const ENSURE_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER = 'ENSURE_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER';
export const LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER = 'LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER';
export const LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_FAILURE = 'LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_FAILURE';
export const LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_PENDING = 'LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_PENDING';
export const LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_SUCCESS = 'LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_SUCCESS';

export const ENSURE_BUNDLE_ALERT_DEFINITIONS = 'ENSURE_BUNDLE_ALERT_DEFINITIONS';
export const LOAD_BUNDLE_ALERT_DEFINITIONS = 'LOAD_BUNDLE_ALERT_DEFINITIONS';
export const LOAD_BUNDLE_ALERT_DEFINITIONS_FAILURE = 'LOAD_BUNDLE_ALERT_DEFINITIONS_FAILURE';
export const LOAD_BUNDLE_ALERT_DEFINITIONS_PENDING = 'LOAD_BUNDLE_ALERT_DEFINITIONS_PENDING';
export const LOAD_BUNDLE_ALERT_DEFINITIONS_SUCCESS = 'LOAD_BUNDLE_ALERT_DEFINITIONS_SUCCESS';

export const CREATE_BUNDLE_ALERT_DEFINITION = 'CREATE_BUNDLE_ALERT_DEFINITION';
export const CREATE_BUNDLE_ALERT_DEFINITION_FAILURE = 'CREATE_BUNDLE_ALERT_DEFINITION_FAILURE';
export const CREATE_BUNDLE_ALERT_DEFINITION_PENDING = 'CREATE_BUNDLE_ALERT_DEFINITION_PENDING';
export const CREATE_BUNDLE_ALERT_DEFINITION_SUCCESS = 'CREATE_BUNDLE_ALERT_DEFINITION_SUCCESS';

export const DELETE_BUNDLE_ALERT_DEFINITION = 'DELETE_BUNDLE_ALERT_DEFINITION';

export const UPDATE_BUNDLE_ALERT_DEFINITION = 'UPDATE_BUNDLE_ALERT_DEFINITION';
export const UPDATE_BUNDLE_ALERT_DEFINITION_FAILURE = 'UPDATE_BUNDLE_ALERT_DEFINITION_FAILURE';
export const UPDATE_BUNDLE_ALERT_DEFINITION_SUCCESS = 'UPDATE_BUNDLE_ALERT_DEFINITION_SUCCESS';

export const DELETE_BUNDLE_ALERT_DEFINITION_FAILURE = 'DELETE_BUNDLE_ALERT_DEFINITION_FAILURE';
export const DELETE_BUNDLE_ALERT_DEFINITION_SUCCESS = 'DELETE_BUNDLE_ALERT_DEFINITION_SUCCESS';

export const ENSURE_COMMAND_DEFINITIONS = 'ENSURE_COMMAND_DEFINITIONS';
export const LOAD_COMMAND_DEFINITIONS = 'LOAD_COMMAND_DEFINITIONS';
export const LOAD_COMMAND_DEFINITIONS_FAILURE = 'LOAD_COMMAND_DEFINITIONS_FAILURE';
export const LOAD_COMMAND_DEFINITIONS_PENDING = 'LOAD_COMMAND_DEFINITIONS_PENDING';
export const LOAD_COMMAND_DEFINITIONS_SUCCESS = 'LOAD_COMMAND_DEFINITIONS_SUCCESS';

export const ENSURE_COMMAND_TYPES = 'ENSURE_COMMAND_TYPES';
export const LOAD_COMMAND_TYPES = 'LOAD_COMMAND_TYPES';
export const LOAD_COMMAND_TYPES_FAILURE = 'LOAD_COMMAND_TYPES_FAILURE';
export const LOAD_COMMAND_TYPES_PENDING = 'LOAD_COMMAND_TYPES_PENDING';
export const LOAD_COMMAND_TYPES_SUCCESS = 'LOAD_COMMAND_TYPES_SUCCESS';

export const ENSURE_COMMAND_STOCKS = 'ENSURE_COMMAND_STOCKS';
export const LOAD_COMMAND_STOCKS = 'LOAD_COMMAND_STOCKS';
export const LOAD_COMMAND_STOCKS_FAILURE = 'LOAD_COMMAND_STOCKS_FAILURE';
export const LOAD_COMMAND_STOCKS_PENDING = 'LOAD_COMMAND_STOCKS_PENDING';
export const LOAD_COMMAND_STOCKS_SUCCESS = 'LOAD_COMMAND_STOCKS_SUCCESS';

export const SIM_PROVISION_SET_NETWORK_TARIFF = 'SIM_PROVISION_SET_NETWORK_TARIFF';
export const SIM_PROVISION_CLEAR_NETWORK_TARIFF = 'SIM_PROVISION_CLEAR_NETWORK_TARIFF';
export const SIM_PROVISION_ADD_TARIFF_BOLT_ON = 'SIM_PROVISION_ADD_TARIFF_BOLT_ON';
export const SIM_PROVISION_REMOVE_TARIFF_BOLT_ON = 'SIM_PROVISION_REMOVE_TARIFF_BOLT_ON';

export const SIM_COMMAND_SET_DATE = 'SIM_COMMAND_SET_DATE';
export const SIM_COMMAND_SET_PO = 'SIM_COMMAND_SET_PO';
export const SIM_COMMAND_SET_VALUE = 'SIM_COMMAND_SET_VALUE';
export const SIM_SUBMISSION_SET_ACTION_DATE = 'SIM_SUBMISSION_SET_ACTION_DATE';
export const SIM_SUBMISSION_SET_ACTION_IMMEDIATELY = 'SIM_SUBMISSION_SET_ACTION_IMMEDIATELY';
export const SIM_SUBMISSION_SET_NAME = 'SIM_SUBMISSION_SET_NAME';


export const ENSURE_NETWORK_TARIFFS = 'ENSURE_NETWORK_TARIFFS';
export const LOAD_NETWORK_TARIFFS = 'LOAD_NETWORK_TARIFFS';
export const LOAD_NETWORK_TARIFFS_FAILURE = 'LOAD_NETWORK_TARIFFS_FAILURE';
export const LOAD_NETWORK_TARIFFS_PENDING = 'LOAD_NETWORK_TARIFFS_PENDING';
export const LOAD_NETWORK_TARIFFS_SUCCESS = 'LOAD_NETWORK_TARIFFS_SUCCESS';

export const ENSURE_NETWORK_BUNDLE_TOPUPS = 'ENSURE_NETWORK_BUNDLE_TOPUPS';
export const LOAD_NETWORK_BUNDLE_TOPUPS = 'LOAD_NETWORK_BUNDLE_TOPUPS';
export const LOAD_NETWORK_BUNDLE_TOPUPS_FAILURE = 'LOAD_NETWORK_BUNDLE_TOPUPS_FAILURE';
export const LOAD_NETWORK_BUNDLE_TOPUPS_PENDING = 'LOAD_NETWORK_BUNDLE_TOPUPS_PENDING';
export const LOAD_NETWORK_BUNDLE_TOPUPS_SUCCESS = 'LOAD_NETWORK_BUNDLE_TOPUPS_SUCCESS';

export const ENSURE_ORANGE_ZONES = 'ENSURE_ORANGE_ZONES';
export const LOAD_ORANGE_ZONES = 'LOAD_ORANGE_ZONES';
export const LOAD_ORANGE_ZONES_PENDING = 'LOAD_ORANGE_ZONES_PENDING';
export const LOAD_ORANGE_ZONES_FAILURE = 'LOAD_ORANGE_ZONES_FAILURE';
export const LOAD_ORANGE_ZONES_SUCCESS = 'LOAD_ORANGE_ZONES_SUCCESS';

export const ENSURE_ACCOUNT_ORANGE_ZONES = 'ENSURE_ACCOUNT_ORANGE_ZONES';
export const LOAD_ACCOUNT_ORANGE_ZONES = 'LOAD_ACCOUNT_ORANGE_ZONES';
export const LOAD_ACCOUNT_ORANGE_ZONES_PENDING = 'LOAD_ACCOUNT_ORANGE_ZONES_PENDING';
export const LOAD_ACCOUNT_ORANGE_ZONES_FAILURE = 'LOAD_ACCOUNT_ORANGE_ZONES_FAILURE';
export const LOAD_ACCOUNT_ORANGE_ZONES_SUCCESS = 'LOAD_ACCOUNT_ORANGE_ZONES_SUCCESS';

export const ENSURE_MVNO_TEMPLATES = 'ENSURE_MVNO_TEMPLATES';
export const LOAD_MVNO_TEMPLATES = 'LOAD_MVNO_TEMPLATES';
export const LOAD_MVNO_TEMPLATES_PENDING = 'LOAD_MVNO_TEMPLATES_PENDING';
export const LOAD_MVNO_TEMPLATES_FAILURE = 'LOAD_MVNO_TEMPLATES_FAILURE';
export const LOAD_MVNO_TEMPLATES_SUCCESS = 'LOAD_MVNO_TEMPLATES_SUCCESS';

export const ENSURE_PORT_NETWORKS = 'ENSURE_PORT_NETWORKS';
export const LOAD_PORT_NETWORKS = 'LOAD_PORT_NETWORKS';
export const LOAD_PORT_NETWORKS_PENDING = 'LOAD_PORT_NETWORKS_PENDING';
export const LOAD_PORT_NETWORKS_FAILURE = 'LOAD_PORT_NETWORKS_FAILURE';
export const LOAD_PORT_NETWORKS_SUCCESS = 'LOAD_PORT_NETWORKS_SUCCESS';

export const ENSURE_PROVISIONING_EXCLUDED_DAYS = 'ENSURE_PROVISIONING_EXCLUDED_DAYS';
export const LOAD_PROVISIONING_EXCLUDED_DAYS = 'LOAD_PROVISIONING_EXCLUDED_DAYS';
export const LOAD_PROVISIONING_EXCLUDED_DAYS_FAILURE = 'LOAD_PROVISIONING_EXCLUDED_DAYS_FAILURE';
export const LOAD_PROVISIONING_EXCLUDED_DAYS_PENDING = 'LOAD_PROVISIONING_EXCLUDED_DAYS_PENDING';
export const LOAD_PROVISIONING_EXCLUDED_DAYS_SUCCESS = 'LOAD_PROVISIONING_EXCLUDED_DAYS_SUCCESS';

export const ENSURE_TARIFF_BOLT_ONS = 'ENSURE_TARIFF_BOLT_ONS';
export const LOAD_TARIFF_BOLT_ONS = 'LOAD_TARIFF_BOLT_ONS';
export const LOAD_TARIFF_BOLT_ONS_FAILURE = 'LOAD_TARIFF_BOLT_ONS_FAILURE';
export const LOAD_TARIFF_BOLT_ONS_PENDING = 'LOAD_TARIFF_BOLT_ONS_PENDING';
export const LOAD_TARIFF_BOLT_ONS_SUCCESS = 'LOAD_TARIFF_BOLT_ONS_SUCCESS';

export const SIM_PROVISION_TEL_CHANGED = 'SIM_PROVISION_TEL_CHANGED';
export const SIM_SWAP_SERIAL_CHANGED = 'SIM_SWAP_SERIAL_CHANGED';
export const SIM_SWAP_SERIAL_CHANGED_ASYNC = 'SIM_SWAP_SERIAL_CHANGED_ASYNC';
export const MSISDN_SWAP_TEL_CHANGED = 'MSISDN_SWAP_TEL_CHANGED';

// SIM submission
export const CHANGE_SIM_SUBMISSIONS_SELECTED = 'CHANGE_SIM_SUBMISSIONS_SELECTED';
export const CREATE_SIM_SUBMISSION = 'CREATE_SIM_SUBMISSION';
export const CREATE_SIM_SUBMISSION_FAILURE = 'CREATE_SIM_SUBMISSION_FAILURE';
export const CREATE_SIM_SUBMISSION_SUCCESS = 'CREATE_SIM_SUBMISSION_SUCCESS';
export const CLEAR_SELECTED_SIM_SUBMISSION = 'CLEAR_SELECTED_SIM_SUBMISSION';
export const EXPORT_SIM_SUBMISSION = 'EXPORT_SIM_SUBMISSION';
export const ENSURE_SELECTED_SIM_SUBMISSION = 'ENSURE_SELECTED_SIM_SUBMISSION';
export const LOAD_SELECTED_SIM_SUBMISSION = 'LOAD_SELECTED_SIM_SUBMISSION';
export const LOAD_SELECTED_SIM_SUBMISSION_FAILURE = 'LOAD_SELECTED_SIM_SUBMISSION_FAILURE';
export const LOAD_SELECTED_SIM_SUBMISSION_SUCCESS = 'LOAD_SELECTED_SIM_SUBMISSION_SUCCESS';
export const BULK_CONFIGURE_SPEND_CAP = 'BULK_CONFIGURE_SPEND_CAP';
export const BULK_DELETE_SPEND_CAP = 'BULK_DELETE_SPEND_CAP';
export const CLEAR_SIM_SUBMISSION = 'CLEAR_SIM_SUBMISSION';

// SIM submissions
export const CANCEL_SIM_SUBMISSION = 'CANCEL_SIM_SUBMISSION';
export const CANCEL_SIM_SUBMISSION_FAILURE = 'CANCEL_SIM_SUBMISSION_FAILURE';
export const CANCEL_SIM_SUBMISSION_SUCCESS = 'CANCEL_SIM_SUBMISSION_SUCCESS';
export const COMPLETE_SIM_SUBMISSION = 'COMPLETE_SIM_SUBMISSION';
export const COMPLETE_SIM_SUBMISSION_FAILURE = 'COMPLETE_SIM_SUBMISSION_FAILURE';
export const COMPLETE_SIM_SUBMISSION_SUCCESS = 'COMPLETE_SIM_SUBMISSION_SUCCESS';
export const CLEAR_SIM_SUBMISSIONS = 'CLEAR_SIM_SUBMISSIONS';
export const ENSURE_SIM_SUBMISSIONS = 'ENSURE_SIM_SUBMISSIONS';
export const LOAD_SIM_SUBMISSIONS = 'LOAD_SIM_SUBMISSIONS';
export const LOAD_SIM_SUBMISSIONS_FAILURE = 'LOAD_SIM_SUBMISSIONS_FAILURE';
export const LOAD_SIM_SUBMISSIONS_SUCCESS = 'LOAD_SIM_SUBMISSIONS_SUCCESS';

// user settings
export const ENSURE_USER_SETTINGS = 'ENSURE_USER_SETTINGS';
export const LOAD_USER_SETTINGS = 'LOAD_USER_SETTINGS';
export const LOAD_USER_SETTINGS_FAILURE = 'LOAD_USER_SETTINGS_FAILURE';
export const LOAD_USER_SETTINGS_PENDING = 'LOAD_USER_SETTINGS_PENDING';
export const LOAD_USER_SETTINGS_SUCCESS = 'LOAD_USER_SETTINGS_SUCCESS';
export const PUT_USER_SETTINGS = 'PUT_USER_SETTINGS';
export const PUT_USER_SETTINGS_FAILURE = 'PUT_USER_SETTINGS_FAILURE';
export const PUT_USER_SETTINGS_SUCCESS = 'PUT_USER_SETTINGS_SUCCESS';
export const DELETE_USER_SETTINGS = 'DELETE_USER_SETTINGS';
export const DELETE_USER_SETTINGS_FAILURE = 'DELETE_USER_SETTINGS_FAILURE';
export const DELETE_USER_SETTINGS_SUCCESS = 'DELETE_USER_SETTINGS_SUCCESS';
